import { IKizViewDTO } from "../../../../libs/coreapi-dto/dirs/kiz";

export function convert2DtoView(kizs: IKizViewDTO[]): IKizViewDTO[] {
  return kizs.map(kiz => {
    if (kiz.gtin && kiz.gtin.length > 0) {
      const cleanedGtin = kiz.gtin
        .replace(/\s*\(сохранён\)\s*/g, '')
        .trim();
      return { ...kiz, gtin: cleanedGtin };
    }
    return kiz;
  });
}